<template>
  <v-container fluid fill-height>
    <v-row no-gutters align="center" justify="space-around">
      <v-col cols="12" md="8">
        <v-card ref="form">
          <v-card-text>
            <v-text-field
              ref="last_name"
              v-model="last_name"
              :rules="[() => !!last_name || 'Este campo es requerido']"
              label="Apellidos Completos *"
              required
            />
            <v-text-field
              ref="name"
              v-model="name"
              :rules="[() => !!name || 'Este campo es requerido']"
              label="Nombres Completos *"
              required
            />

            <v-text-field
              ref="email"
              v-model="email"
              :rules="[() => !!email || 'Este campo es requerido']"
              label="Email *"
              required
            />

            <v-text-field
              ref="password"
              v-model="password"
              :rules="[
                () => !!password || 'Este campo es requerido',
                () =>
                  (!!password &&
                    password.length >= 8 &&
                    password.length <= 12) ||
                  'Contrasena debe ser mayor a 8 caracteres o menor a 12 '
              ]"
              :append-icon="show1 ? 'mdi-account' : 'mdi-account-alert'"
              :type="show1 ? 'text' : 'password'"
              label="Contraseña *"
              counter="12"
              required
            />
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="cancel">Cancelar</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" text type="submit" @click="submit">Registrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!--SnackBar for errors-->
    <v-snackbar v-model="snackbar" :right="true" :timeout="3000" :top="true">
      {{ message }}
      <v-btn color="pink" text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import * as firebase from "firebase";

export default {
  data() {
    return {
      name: "",
      last_name: "",
      email: "",
      password: "",
      expert: false,
      show1: false,
      snackbar: false,
      message: ""
    };
  },

  methods: {
    
    submit: function() {
      // eslint-disable-next-line no-console
      console.log("Ingresando datos del usuario: ");

      const newUser = {
        id: null,
        last_name: this.last_name,
        name: this.name,
        email: this.email,
        fullName: this.name + " " + this.last_name
      };

      // eslint-disable-next-line no-console
      console.log(newUser);

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(user => {
          newUser.id = user.user.uid;
          this.$router.push("Loading");
          this.$store.dispatch("user/signUpUser", newUser)
          .then(() => {
            this.$router.push({ name: "projects" });
            location.reload();
          });
        })
        .catch(err => {
          
          // eslint-disable-next-line no-console
          console.log("Error" + err.message);
          if (
            err.message ==
            "The email address is already in use by another account."
          ) {
            this.message = "El correo electrónico pertenece a otra cuenta";
            this.snackbar = true;
          }else{
            // eslint-disable-next-line no-console
          console.log("Credenciales incorrectas limpiando los text fields..");
          this.alert = true;
          this.last_name = "";
          this.name = "";
          this.email = "";
          this.password = "";
          }
        });
    },

    resetForm() {
      this.name = "";
      this.last_name = "";
      this.email = "";
      this.password = "";
    },
    cancel() {
      this.$router.push({ name: "login" });
    }
  },
  computed: {
    ...mapState(["snackbar"]),
    fullName: function() {
      return `${this.name.split(" ")[0]} ${this.last_name.split(" ")[0]}`;
    }
  }
};
</script>
